import React from "react";
import ImageSide from "../../shared/ImageSide";
import { distanceBodyCoding } from "../../../data/body-coding/distance-body-coding";

const DistanceBodyCoding = () => {
	return (
		<ImageSide left={false} imageSrc="images/distance-body-coding.svg">
			<h2 className="fw-bold display-5 mb-5">{distanceBodyCoding.heading}</h2>
			<ul>
				{distanceBodyCoding.content.map((c, index) => (
					<li key={index} className="fs-5 mb-2">{c}</li>
				))}
			</ul>
		</ImageSide>
	);
};

export default DistanceBodyCoding;